import React, { useState } from 'react';
import DateSelect from '../DateSelect';
import SpinnerGrowLoading from './SpinnerGrowLoading';

function ValueMetric({ url, label, range, startDate, endDate }) {
    const [data, setData] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex">
                    <div>
                        <span className="text-muted">{label}</span>
                        <SpinnerGrowLoading isLoading={isLoading}>
                            <h3 className="font-light m-b-5">{data}</h3>
                        </SpinnerGrowLoading>
                    </div>
                    <div className="ml-auto metrics_datepicker">
                        <DateSelect
                            url={url}
                            setData={setData}
                            setIsLoading={setIsLoading}
                            defaultRange={range}
                            defaultStartDate={startDate}
                            defaultEndDate={endDate}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ValueMetric;
